module.exports = __webpack_public_path__ + "static/arcadium-case-study-981d12029a8ba167250b835f18519c09.webp";